import './Secondpage.css';

function What(){
    return(
        <div className="">
            <label className="what-do">What We Do</label>
            <div className="all-icons">
            <i class="fa-solid fa-rocket"></i>
            <i class="fa-solid fa-handshake"></i>
            <i class="fa-solid fa-hand-pointer"></i>
            <div className="all-text">
            <p className="icons-text">Research User needs</p>
            <p className="icons-text">Business Strategy</p>
            <p className="icons-text">Automation</p>
            </div>
            <div className="all-text1">
                <p class="passage">Discover pain pointes and</p>
                <p class="passage">Validate ideas with an</p>
                <p class="passage">Lanch na MVP with a best in</p>
            </div>
            <div className="all-text2">
                <p class="passage">Understand user behaviour</p>
                <p class="passage">Intractive prototype of your</p>
                <p class="passage">Class user experience</p>
            </div>
            </div>
        </div>
    )
}

export default What;